import styled from 'styled-components';

export const FieldInput = styled.div`
  max-width: 512px;
`;
